const TradePendingSearch = () => {
    return (
        <div>Trade pending search</div>
    );
};

export { 
    TradePendingSearch
};